module.exports = __webpack_public_path__ + "media/images/Rectangle_3-274a54b04bd530b25c06e99794428608.png";